import {Link} from "react-router-dom";
import {Role, RoleEnumToString} from "../../api/accessControl/Role.ts";
import {Menu, MenuButton, MenuItem, MenuItems} from "@headlessui/react";
import {ArrowRightOnRectangleIcon, Cog6ToothIcon} from "@heroicons/react/24/outline";
import {Tag} from "../general/Tag.tsx";
import {signOut} from "firebase/auth";
import {confirmLeavingPendingUploads} from "../../utils/pendingUploads.ts";
import {auth} from "../../firebaseApp.ts";
import {UserAccess} from "../../api/accessControl/User.ts";
import {logInWithBusiness} from "../../utils/OrgManagement.ts";

const roleDisplayName = {
    'admin': 'Admin',
    'partner': 'Partner',
    'entrepreneur': 'Ondernemer',
}

export function UserBadge(props: {
    firstName: string,
    lastName: string,
    email: string,
    role: Role,
    businessName: string,
    access: UserAccess,
    collapsed?: boolean
}) {
    async function handleLogout() {
        if (!confirmLeavingPendingUploads()) return;
        signOut(auth).then(() => {
            window.location.replace('/')
        })
    }

    return (
        <Menu as="div" className="relative flex flex-col items-center overflow-visible">
            <MenuButton
                className={`flex w-full items-center ${props.collapsed ? 'justify-center' : 'gap-x-4 px-4'} py-3 text-sm font-semibold text-gray-900 hover:bg-gray-50 transition-all duration-300`}>
                <div className="rounded-full bg-superliteprimary p-3 shrink-0">
                    <span className="text-primary">{props.firstName.charAt(0)}{props.lastName.charAt(0)}</span>
                </div>

                {!props.collapsed && (
                    <div className="text-left truncate">
                        <div>
                            <span className="block truncate">{props.firstName} {props.lastName} {props.role === Role.Admin &&
                                <span className="mt-0 mb-0 pt-0 text-xs text-gray-700">👑</span>}</span>
                            <span className="text-xs text-gray-600 truncate">{props.businessName}</span>
                        </div>
                    </div>
                )}
            </MenuButton>

            <MenuItems
                transition
                anchor={{ to: "top start", gap: 8 }}
                className="z-50 w-72 origin-bottom rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
            >
                <div className="py-1">
                    <div className="px-4 py-2">
                        <p className="text-sm font-medium text-gray-900 mb-1">{props.firstName} {props.lastName} <Tag
                            variant="secondary" size="xs"
                            className="ml-1">{roleDisplayName[RoleEnumToString(props.role as Role)]}</Tag></p>
                        <p className="text-sm text-gray-500 truncate max-w-[40ch]">{props.email} </p>
                        <p className="text-xs text-gray-400 mt-1">

                        </p>
                    </div>

                    {props.access && props.access.length > 1 && (
                        <div className="border-t border-gray-100 py-2">
                            {props.access.map((biz) => (
                                <MenuItem key={biz.business_id} as="div" className=" w-full hover:bg-gray-100">
                                    <button
                                        onClick={() => logInWithBusiness(biz.business_id)}
                                        className={`flex w-full mb-0.5 px-4 py-1 items-center text-sm ${biz.business_name === props.businessName ? 'font-bold text-primary' : 'text-gray-500'}`}
                                    >
                                        <div
                                            className={`rounded-sm ${biz.business_name === props.businessName ? ' bg-superliteprimary' : ' bg-gray-100'}  p-1 mr-1 w-[4ch] text-center`}>
                                            <span
                                                className="">{biz.business_name.split(' ').slice(0, 2).map((word) => word.charAt(0)).join('')}</span>
                                        </div>
                                        <span className="ml-1 truncate">{biz.business_name}</span>
                                    </button>
                                </MenuItem>
                            ))}
                        </div>
                    )}

                    <MenuItem as="div" className="border-t border-gray-100 mt-1 pt-3 px-4 py-2 hover:bg-gray-100">
                        <Link
                            to="/my-profile"
                            className="flex w-full items-center text-sm text-gray-700 gap-x-2"
                        >
                            <Cog6ToothIcon className="h-5 w-5 text-gray-400"/>
                            Instellingen
                        </Link>
                    </MenuItem>

                    <MenuItem as="div" className="px-4 py-2 hover:bg-gray-100">
                        <button
                            onClick={handleLogout}
                            className="flex w-full items-center text-sm text-gray-700 gap-x-2"
                        >
                            <ArrowRightOnRectangleIcon className="h-5 w-5 text-gray-400"/>
                            Uitloggen
                        </button>
                    </MenuItem>
                </div>
            </MenuItems>
        </Menu>
    );
}
